// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AddOnTotalController from './add_on_total_controller'
application.register('add-on-total', AddOnTotalController)

import AutosubmitController from './autosubmit_controller'
application.register('autosubmit', AutosubmitController)

import AutoTabsController from './auto_tabs_controller'
application.register('auto-tabs', AutoTabsController)

import BulkSelectController from './bulk_select_controller'
application.register('bulk-select', BulkSelectController)

import ChartController from './chart_controller'
application.register('chart', ChartController)

import CopyToClipboardController from './copy_to_clipboard_controller'
application.register('copy-to-clipboard', CopyToClipboardController)

import DatatableController from './datatable_controller'
application.register('datatable', DatatableController)

import TableLiveFooterController from './table_live_footer_controller'
application.register('table-live-footer', TableLiveFooterController)

import DateRangeDropdownController from './date_range_dropdown_controller'
application.register('date-range-dropdown', DateRangeDropdownController)

import DismissModalController from './dismiss_modal_controller'
application.register('dismiss-modal', DismissModalController)

import DirectReservationController from './direct_reservation_controller'
application.register('direct-reservation', DirectReservationController)

import DirectRentalReservationController from './direct_rental_reservation_controller'
application.register('direct-rental-reservation', DirectRentalReservationController)

import AssignmentReorderController from './assignment_reorder_controller'
application.register('assignment-reorder', AssignmentReorderController)

import SlotSelectController from './slot_select_controller'
application.register('slot-select', SlotSelectController)

import EditReservationController from './edit_reservation_controller'
application.register('edit-reservation', EditReservationController)

import FlatpickrController from './flatpickr_controller'
application.register('flatpickr', FlatpickrController)

import LightboxController from './lightbox_controller'
application.register('lightbox', LightboxController)

import ExclusiveInputsController from './exclusive_inputs_controller'
application.register('exclusive-inputs', ExclusiveInputsController)

import FeeCalculatorController from './fee_calculator_controller'
application.register('fee-calculator', FeeCalculatorController)

import FlatpickrMonthController from './flatpickr_month_controller'
application.register('flatpickr-month', FlatpickrMonthController)

import FlatpickrRangeController from './flatpickr_range_controller'
application.register('flatpickr-range', FlatpickrRangeController)

import GiftCardController from './gift_card_controller'
application.register('gift-card', GiftCardController)

import GiftCardFormController from './gift_card_form_controller'
application.register('gift-card-form', GiftCardFormController)

import PromoCodeController from './promo_code_controller'
application.register('promo-code', PromoCodeController)

import PromoCodeFormController from './promo_code_form_controller'
application.register('promo-code-form', PromoCodeFormController)

import MaskController from './mask_controller'
application.register('mask', MaskController)

import MidnightRefreshController from './midnight_refresh_controller'
application.register('midnight-refresh', MidnightRefreshController)

import NameSuggestController from './name_suggest_controller'
application.register('name-suggest', NameSuggestController)

import NotificationPopupController from './notification_popup_controller'
application.register('notification-popup', NotificationPopupController)

import MultiChartController from './multi_chart_controller'
application.register('multi-chart', MultiChartController)

import PhoneController from './phone_controller'
application.register('phone', PhoneController)

import PopoverController from './popover_controller'
application.register('popover', PopoverController)

import ReservationFilterController from './reservation_filter_controller'
application.register('reservation-filter', ReservationFilterController)

import ReservationFormController from './reservation_form_controller'
application.register('reservation-form', ReservationFormController)

import SelectAllController from './select_all_controller'
application.register('select-all', SelectAllController)

import StarRatingController from './star_rating_controller'
application.register('star-rating', StarRatingController)

import StripePaymentController from './stripe_payment_controller'
application.register('stripe-payment', StripePaymentController)

import TicketOrderController from './ticket_order_controller'
application.register('ticket-order', TicketOrderController)

import TicketQtyValidatorController from './ticket_qty_validator_controller'
application.register('ticket-qty-validator', TicketQtyValidatorController)

import ToastController from './toast_controller'
application.register('toast', ToastController)

import InputToggleController from './input_toggle_controller'
application.register('input-toggle', InputToggleController)

import ToggleController from './toggle_controller'
application.register('toggle', ToggleController)

import TooltipController from './tooltip_controller'
application.register('tooltip', TooltipController)

import TurboModalController from './turbo_modal_controller'
application.register('turbo-modal', TurboModalController)

import YoutubeEmbedController from './youtube_embed_controller'
application.register('youtube-embed', YoutubeEmbedController)

import Sortable from '@stimulus-components/sortable'
application.register('sortable', Sortable)

import RailsNestedForm from '@stimulus-components/rails-nested-form'
application.register('nested-form', RailsNestedForm)
application.register('nested-form-crew-members', RailsNestedForm)
application.register('nested-form-custom-fields', RailsNestedForm)

import GatewayPaymentController from './gateway_payment_controller'
application.register('gateway-payment', GatewayPaymentController)

import HeatMapController from './heat_map_controller'
application.register('heat-map', HeatMapController)

import SignaturePadController from './signature_pad_controller'
application.register('signature-pad', SignaturePadController)

import CharterFinancialController from './charter_financial_controller'
application.register('charter-financial', CharterFinancialController)

import PricingToggleController from './pricing_toggle_controller'
application.register('pricing-toggle', PricingToggleController)

import CharterFormController from './charter_form_controller'
application.register('charter-form', CharterFormController)

import ScheduleDayController from './schedule_day_controller'
application.register('schedule-day', ScheduleDayController)

import RentalBookingController from './rental_booking_controller'
application.register('rental-booking', RentalBookingController)

import RefundFormController from './refund_form_controller'
application.register('refund-form', RefundFormController)

import LuminaryGridController from './luminary_grid_controller'
application.register('luminary-grid', LuminaryGridController)

import RevealController from './reveal_controller'
application.register('reveal', RevealController)

import SiteNavController from './site_nav_controller'
application.register('site-nav', SiteNavController)

import WaiversSummaryController from './waivers_summary_controller'
application.register('waivers-summary', WaiversSummaryController)
